import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import jsRedirect from '../../../helpers/jsRedirect';
import { Col } from '../../base/Grid';
import Link from '../../base/Link';

import {
  DivProductCalloutCardStyled,
  ProductCalloutRow,
  RowHeaderStyled,
  TypographyHeaderStyled,
  TypographyCardCopyStyled,
  IconCardTitleStyled,
  ButtonCondensedCardOverlayStyled,
  ColLinkContainerStyled,
  Styles,
} from './styles';

// If the card is condensed, the button overlay will kick in to handle link functionality,
// and the button props will be applied to the CTA. (buttonId and buttonUrl)

export const ProductCalloutComponent = ({
  bgVariant,
  condensed,
  icon,
  cardId,
  title,
  copy,
  linkId,
  linkText,
  linkUrl,
  config,
}) => {
  const styles = Styles();
  const IconToRender = icon;
  return (
    <DivProductCalloutCardStyled
    bgVariant={bgVariant}
    id={cardId}
    condensed={condensed}>
      <ProductCalloutRow condensed={condensed}>
      </ProductCalloutRow>
      <ProductCalloutRow>
        <Col xsmall={12}>
          <RowHeaderStyled>
            <TypographyHeaderStyled
            component='h3'
            condensed={condensed}>
              {title}
              {condensed
              && <IconCardTitleStyled
                className='icon-product-callout-arrow' />}
            </TypographyHeaderStyled>
            {icon && !condensed
            && (
              <IconToRender style={styles.IconCardMainStyled} />
            )}
          </RowHeaderStyled>
          {(copy && !condensed)
        && <TypographyCardCopyStyled
          component='p'>
          {copy}
        </TypographyCardCopyStyled>}
        </Col>
      </ProductCalloutRow>
      {linkText
      && (
        <ProductCalloutRow
          condensed={condensed}
          className='nmx-no-print'>
          <ColLinkContainerStyled xsmall={12}>
            <Link
              id={linkId}
              variant='secondary'
              href={linkUrl}
              config={config}>
              {linkText}
            </Link>
          </ColLinkContainerStyled>
        </ProductCalloutRow>
      )}
      {condensed
      && <ButtonCondensedCardOverlayStyled
        id={`${cardId}-button`}
        aria-label={`${title}`}
        role='link'
        onClick={() => {
          jsRedirect(linkUrl);
        }} />}
    </DivProductCalloutCardStyled>
  );
};

ProductCalloutComponent.propTypes = {
  bgVariant: PropTypes.string,
  condensed: PropTypes.bool,
  icon: PropTypes.any,
  cardId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  copy: PropTypes.any,
  linkId: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  config: PropTypes.shape({
    basePath: PropTypes.string,
    nmxTemplateVersion: PropTypes.string,
  }),
};

ProductCalloutComponent.defaultProps = {
  bgVariant: 'secondary',
  condensed: false,
  config: {
    basePath: '<%=basePath%>',
    nmxTemplateVersion: '<%=nmxTemplateVersion%>',
  },
};

export default withTheme(ProductCalloutComponent);
